import { Link, TrackingData } from '@ecm/router';

export class ItemHelpViewModel {
    public cid?: string;
    public text: string;
    public link?: Link;
    public trackingData?: TrackingData;
}
